"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
function getkeys(obj) { return Object.keys(obj); }
function isPrimitive(test) {
    return (test !== Object(test));
}
function keyEqual(a, b) {
    var equal = true;
    if (getkeys(a).length !== getkeys(b).length) {
        return false;
    }
    for (var key in a) {
        if (key in b) {
            continue;
        }
        equal = false;
    }
    for (var key in b) {
        if (key in a) {
            continue;
        }
        equal = false;
    }
    return equal;
}
exports.keyEqual = keyEqual;
function objectDeepEqual(a, b) {
    if (!(utils_1.isObject(a) && utils_1.isObject(b))) {
        return false;
    }
    function traverse(aa, bb) {
        if (aa === bb) {
            return true;
        }
        if ((isPrimitive(aa) && isPrimitive(bb)) ||
            typeof aa === 'function' && typeof bb === 'function') {
            return aa === bb;
        }
        var isKeyEqual = keyEqual(aa, bb);
        if (!isKeyEqual) {
            return isKeyEqual;
        }
        var keys = getkeys(aa);
        var length = keys.length;
        for (var i = length; i-- !== 0;) {
            var key = keys[i];
            if (!traverse(aa[key], bb[key])) {
                return false;
            }
        }
        return true;
    }
    return traverse(a, b);
}
exports.objectDeepEqual = objectDeepEqual;



// WEBPACK FOOTER //
// ./src/dist/commonjs/helpers/equal.js